import { useQuery } from "@tanstack/react-query";
import { getModerationStats } from "@/services/adminApi";

const autoRefresh = import.meta.env.VITE_AUTO_REFRESH === "true";

export function useModerationStats() {
  return useQuery({
    queryKey: ["admin", "moderation", "stats"],
    queryFn: getModerationStats,
    refetchInterval: autoRefresh ? 30000 : false,
  });
}
